import React from 'react';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';

const StyledErrorText = styled(Typography)(({ theme }) => ({
  color: theme.palette.danger.main,
}));

const ErrorText = ({ text }) => <StyledErrorText variant="body2">{text}</StyledErrorText>;

ErrorText.propTypes = {
  text: PropTypes.string.isRequired,
};

export { ErrorText };
